module.exports = __webpack_public_path__ + "static/media/mude.377d684b.mp3";